var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.afterApi
    ? _c(
        "div",
        [
          _vm._m(0),
          _c("div", { staticClass: "member custom-container-xl" }, [
            _c("div", { staticClass: "member__box" }, [
              _c("span", { staticClass: "member__birth" }, [
                _vm._v(_vm._s(_vm.myData.BirthDay))
              ]),
              _c("div", { staticClass: "member__photo" }, [
                _c("div", { staticClass: "photo__inset" }, [
                  _c(
                    "div",
                    { staticClass: "photo__bg" },
                    [
                      _c(
                        "v-avatar",
                        { staticClass: "photo", attrs: { size: "168" } },
                        [_c("img", { attrs: { src: _vm.headImage } })]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "member__space" }),
              _c("div", { staticClass: "member__name" }, [
                _c("div", { staticClass: "member__name__text" }, [
                  _vm._v(_vm._s(_vm.myData.Name))
                ]),
                _c("div", { staticClass: "member__name__uid" }, [
                  _vm._v("\n          ID：" + _vm._s(_vm.UID) + "\n          "),
                  _c("img", {
                    attrs: { src: require("@/assets/icon-copy.svg") },
                    on: {
                      click: function($event) {
                        return _vm.copyClipboard(_vm.UID)
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "member__info" }, [
                _c("div", { staticClass: "info__list" }, [
                  _c("div", { staticClass: "info__item" }, [
                    _c("img", {
                      attrs: { src: require("@/assets/icon_gender.svg") }
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.myData.GenderDisplay))])
                  ]),
                  _c("div", { staticClass: "info__item" }, [
                    _c("img", {
                      attrs: { src: require("@/assets/icon_location.svg") }
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.myData.City))])
                  ]),
                  _c("div", { staticClass: "info__item" }, [
                    _c("img", {
                      attrs: { src: require("@/assets/icon_time.svg") }
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.myData.BirthTime))])
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass: "info__edit",
                    on: {
                      click: function($event) {
                        return _vm.toMemberEdit()
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "ifNotActive",
                      attrs: { src: require("@/assets/icon_edit.svg") }
                    }),
                    _c("img", {
                      staticClass: "ifActive",
                      attrs: { src: require("@/assets/icon_edit_active.svg") }
                    }),
                    _vm._v("\n          编辑\n        ")
                  ]
                )
              ]),
              _vm.hasEligibleCalendar
                ? _c("div", { staticClass: "calendarNotify" }, [
                    _c("div", { staticClass: "calendarNotify__title" }, [
                      _vm._v("共时历")
                    ]),
                    _c(
                      "div",
                      { staticClass: "calendarNotify__switch" },
                      [
                        _c("span", [_vm._v("相位通知")]),
                        _c("SwitchButton", {
                          attrs: { showLabel: false },
                          model: {
                            value: _vm.hasCalendarNotify,
                            callback: function($$v) {
                              _vm.hasCalendarNotify = $$v
                            },
                            expression: "hasCalendarNotify"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.showEdit
              ? _c("div", { staticClass: "toast" }, [_vm._v("该笔资料已修改")])
              : _vm._e()
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header custom-container" }, [
      _c("img", {
        staticClass: "img-title",
        attrs: { src: require("@/assets/header_member.svg"), alt: "" }
      }),
      _c("span", [_vm._v("个人档案")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }